<script>
export default {
  props: ['phone'],
  data() {
    return {
      input: this.phone
    }
  },
  computed: {
    formattedPhone() {
      let formattedPhone = this.input
      if (formattedPhone.startsWith('+1')) {
        formattedPhone = formattedPhone.replace('+1', '')
      }
      formattedPhone = (""+formattedPhone).replace(/\D/g, '')
      if (formattedPhone.length == 7) {
        formattedPhone = '830' + formattedPhone
      }
      let seg = formattedPhone.match(/^(\d{3})(\d{3})(\d{4})$/)
      return (!seg) ? null : "(" + seg[1] + ") " + seg[2] + "-" + seg[3]
    }
  },
  render() {
    return this.$scopedSlots.default({
      inputProps: {
        value: this.formattedPhone
      },
      inputEvents: {
        focusout: e => (this.input = e.target.value)
      }
    })
  }
}
</script>
